// import swal from 'bootstrap-sweetalert';
import swal from 'sweetalert';
require('../assets/vendors/bootstrap-sweetalert/dist/sweetalert.css');

const VueSwal = {};

VueSwal.install = (Vue) => {
  Vue.prototype.$swal = swal;
};

export default VueSwal;



// WEBPACK FOOTER //
// ./src/plugins/vue-swal.js